import {
  base_colorAction,
  base_colorContentBorder,
  cta_buttonPrimaryText,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_lg, font_md, fontH2 } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.ManageSubscriptionPromo {
    width: 100%;
    padding: ${spacing(10)};
    border-radius: 10px;
    border: 1px solid ${base_colorContentBorder};
    background: linear-gradient(
      90deg,
      ${base_colorAction} 0%,
      ${text_colorTextPrimary} 100%
    );
    display: flex;
    flex-direction: column;
    gap: ${spacing(10)};

    .title {
      ${fontH2};
      color: ${cta_buttonPrimaryText};
    }

    .description {
      ${font_lg};
      color: ${cta_buttonPrimaryText};
      width: 60%;
    }

    .disclaimer {
      ${font_md};
      color: ${cta_buttonPrimaryText};
      width: 60%;
      opacity: 0.9;

      .underline-link {
        text-decoration: underline;
      }
    }

    .promo-cards {
      display: flex;
      flex-wrap: wrap;
      gap: ${spacing(6)};
      row-gap: ${spacing(10)};

      .hero-image {
        flex-shrink: 0;
        object-fit: cover;
      }

      .integration-logo {
        width: 48px;
        height: 48px;
      }

      & > * {
        min-width: 340px;
        max-width: 800px;
        flex: 1 1 auto;
      }

      .small-card {
        width: 340px;
      }
      .medium-card {
        width: 540px;
      }
      .large-card {
        width: 680px;
      }
    }
  }
`
